import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';

import { isKnownPath, normalizeRoutePath } from '../app/routes';

export function routeFromDeepLink(rawUrl: string): string | null {
  let parsed: URL;
  try {
    parsed = new URL(rawUrl);
  } catch {
    return null;
  }
  const allowedOrigin = parsed.protocol === 'carryonpan:' || parsed.origin === 'https://carryonpan.com';
  if (!allowedOrigin) return null;
  const path = normalizeRoutePath(parsed.pathname || '/');
  return isKnownPath(path) ? path : null;
}

export async function installNativeLifecycle(onRoute: (path: string) => void) {
  if (!Capacitor.isNativePlatform()) return () => undefined;
  const urlListener = await App.addListener('appUrlOpen', ({ url }) => {
    const route = routeFromDeepLink(url);
    if (route) onRoute(route);
  });
  const stateListener = await App.addListener('appStateChange', ({ isActive }) => {
    if (isActive) localStorage.setItem('carryonpan.lastActiveAt', new Date().toISOString());
  });
  return () => {
    void urlListener.remove();
    void stateListener.remove();
  };
}
